import { Navigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import DashboardLayout from './components/DashboardLayout';
import MainLayout from './components/MainLayout';
import Login from './pages/Login';
import UserStore from './stores/UserStore';
import NotFound from './pages/NotFound';
import BooksStore from './stores/BooksStore';
import SnackStore from './stores/SnackStore';
import MainBookCreate from './pages/MainBookCreate';
import MainBookList from './pages/MainBookList';
import MainBookEdit from './pages/MainBookEdit';
import Quotes from './pages/Quotes';
import BooksCreate from './pages/BooksCreate';
import Reports from './pages/Reports';
import Home from './pages/Home';
import BooksList from './pages/BooksList';
import Wip from './pages/Wip';
import AutomationAction from './pages/AutomationAction';
import Automations from './pages/Automations';
import AutomationPushes from './pages/AutomationPushes';

import ReportSessions from './pages/ReportSessions';
import ReportQuotes from './pages/ReportQuotes';
import MainAuthors from './pages/MainAuthors';
import MainAuthorsCreate from './pages/MainAuthorsCreate';
import MainAuthorsUpdate from './pages/MainAuthorsUpdate';
import TagsManagement from './pages/tags/TagsManagement';
import BookReleases from './pages/BookReleases';

const myUserStore = new UserStore();
const myBooksStore = new BooksStore(myUserStore);
const snackStore = new SnackStore();

const MyDashboardLayout = observer(({ userStore, bookStore, snackStore }) => <DashboardLayout userStore={ userStore } bookStore={ bookStore } snackStore={ snackStore } />);

const routes = [
  {
    path: '/',
    element: <MainLayout userStore={ myUserStore } snackStore={snackStore} />,
    children: [
      { path: '/', element: <Login userStore={ myUserStore } /> },
      { path: '404', element: <NotFound /> },
      { path: '*', element: <Navigate to='/404' /> }
    ]
  },
  {
    path: 'app',
    element: <MyDashboardLayout userStore={ myUserStore } />,
    children: [
      {
        path: '',
        element: <Home bookStore={ myBooksStore } userStore={ myUserStore } snackStore={snackStore} />,
      },
      {
        path: 'books/list',
        element: <BooksList bookStore={ myBooksStore } userStore={ myUserStore } snackStore={snackStore} />
      },
      {
        path: 'books/create',
        element: <BooksCreate bookStore={ myBooksStore } userStore={ myUserStore } snackStore={snackStore} />
      },
      {
        path: 'main/books',
        element: <MainBookList userStore={ myUserStore } snackStore={snackStore} />,
      },
      {
        path: 'main/books/create',
        element: <MainBookCreate userStore={ myUserStore } snackStore={snackStore} />
      },
      {
        path: 'main/books/edit/:id',
        element: <MainBookEdit userStore={ myUserStore } snackStore={snackStore} />
      },
      {
        path: 'main/authors',
        element: <MainAuthors userStore={ myUserStore } snackStore={snackStore} />
      },
      {
        path: 'main/authors/create',
        element: <MainAuthorsCreate userStore={ myUserStore } snackStore={snackStore} />
      },
      {
        path: 'main/authors/:id',
        element: <MainAuthorsUpdate userStore={ myUserStore } snackStore={snackStore} />
      },
      {
        path: 'quotes/:id',
        element: <Quotes userStore={ myUserStore } bookStore={ myBooksStore }  snackStore={snackStore} />
      },
      {
        path: 'users-interactions/fake',
        element: <Wip userStore={ myUserStore } snackStore={snackStore} />
      },
      {
        path: 'automation',
        element: <Automations userStore={ myUserStore }  snackStore={snackStore}/>
      },
      {
        path: 'automation/actions',
        element: <AutomationAction userStore={ myUserStore } snackStore={snackStore} />
      },
      {
        path: 'tags',
        element: <TagsManagement userStore={myUserStore} />
      },
      {
        path: 'automation/pushes',
        element: <AutomationPushes userStore={ myUserStore } snackStore={snackStore} />
      },
      {
        path: 'book-releases',
        element: <BookReleases userStore={ myUserStore } snackStore={snackStore} />
      },
      {
        path: 'reports',
        element: <Reports userStore={ myUserStore } bookStore={ myBooksStore } snackStore={snackStore} />
      },
      {
        path: 'reports/sessions',
        element: <ReportSessions userStore={ myUserStore } snackStore={snackStore} />
      },
      {
        path: 'reports/quotes',
        element: <ReportQuotes userStore={ myUserStore } snackStore={snackStore} />
      },
      { path: '*', element: <Navigate to='/404' /> }
    ]
  }
];

export default routes;
